import { apiClient } from 'pobble-components/dist/api'

const apiSetPresentationAsRecommended = (id, data) =>
  apiClient.put(`/v3/admin/presentations/${id}/set_recommended_until`, data)

const apiSetPresentationCategory = (id, data) =>
  apiClient.put(`/v3/admin/presentations/${id}/set_category`, data)

const apiFlagPresentation = (id, data) =>
  apiClient.put(`/v3/admin/presentations/${id}/flag`, data)

const apiUnflagPresentation = (id, data) =>
  apiClient.put(`/v3/admin/presentations/${id}/unflag`, data)

export {
  apiSetPresentationAsRecommended,
  apiSetPresentationCategory,
  apiFlagPresentation,
  apiUnflagPresentation
}
